/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { toast } from "react-toastify";
import { Box, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { LoadingButton } from "@mui/lab";

import serviceRebalanceUsina from "@/services/serviceRebalanceUsina";

export interface IDialogProps {
    data: { usinaID: number; nomeUsina: string; rebalanceUsinaID: number; cicloFaturamento: string };
    onSuccess: any;
    onClose: any;
}

export default function DialogConfirmRestart({ data, onSuccess, onClose }: IDialogProps) {
    const [loading, setLoading] = useState(false);

    const onSubmit = () => {
        setLoading(true);

        let newValues = {
            rebalanceUsinaID: data.rebalanceUsinaID,
            mes: data.cicloFaturamento.toString().substring(0, 2),
            ano: data.cicloFaturamento.toString().substring(3),
        };

        serviceRebalanceUsina
            .restart(newValues)
            .then((response) => {
                if (response) {
                    toast.info("O Rebalance será reiniciado para a usina selecionada, por favor aguarde.");
                    onClose();
                }
            })
            .finally(() => {
                setLoading(false);
                onSuccess();
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open
        >
            <DialogTitle>
                Atenção
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        onClose();
                    }}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box>
                    <Typography>
                        Rebalance já iniciado para a Usina {data.nomeUsina} - ID: {data.usinaID}. Tem certeza de que
                        deseja reiniciá-lo?
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Não
                </Button>
                <LoadingButton
                    onClick={onSubmit}
                    loading={loading}
                    color="primary"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Sim
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
